/* TS 影片牆 —— 什麼時候播、點開之後怎麼播。

   沒有 JS 的時候：封面圖還在、商品縮圖還在、版面完整，只是不會動也點不開。
   這是刻意的——影片牆的內容本來就該在 HTML 裡。

   每個區塊各自獨立，同一頁放兩個也不會互相干擾。
   <script src> 每出現一次就會執行一次，所以要用旗標擋住重複初始化。 */
if (!window.__tsFeedInit) {
  window.__tsFeedInit = 1;
  (function () {

    // 有沒有真的滑鼠。手機沒有 hover，靠「滑過去才播」等於永遠不播。
    var HOVERABLE = window.matchMedia
      ? window.matchMedia('(hover:hover) and (pointer:fine)').matches : true;

    function throttle(fn, ms) {
      var t = 0, timer = null;
      return function () {
        var now = Date.now();
        if (now - t >= ms) { t = now; fn(); }
        else if (!timer) {
          timer = setTimeout(function () { timer = null; t = Date.now(); fn(); }, ms - (now - t));
        }
      };
    }

    function setup(root) {
      if (root.__ts) return;
      root.__ts = 1;

      var reels = [].slice.call(root.querySelectorAll('.ts-reel'));
      if (!reels.length) return;
      var mode = root.dataset.play || 'hover';

      // ── 播放／暫停 ──
      function play(r) {
        var v = r.querySelector('video');
        if (!v || !v.getAttribute('src')) return;
        var pr = v.play();
        // 自動播放被瀏覽器擋下時 play() 會 reject，接住它，不要在 console 噴錯
        if (pr && pr.catch) pr.catch(function () { r.classList.remove('is-playing'); });
        r.classList.add('is-playing');
      }
      function stop(r) {
        var v = r.querySelector('video');
        if (v) v.pause();
        r.classList.remove('is-playing');
      }
      function stopAll() { reels.forEach(stop); }

      // ── 什麼時候播 ──
      if (mode !== 'off') {
        if (mode === 'hover' && HOVERABLE) {
          reels.forEach(function (r) {
            r.addEventListener('mouseenter', function () { play(r); });
            r.addEventListener('mouseleave', function () { stop(r); });
            r.addEventListener('focus', function () { play(r); });
            r.addEventListener('blur', function () { stop(r); });
          });
        } else if (window.IntersectionObserver) {
          // auto = 看得到就播；hover 落到手機 = 只播離畫面中心最近的那一支。
          // 手機一次只播一支，是為了流量與電量——同時播三支的差別使用者看不出來，帳單看得出來。
          var pickOne = (mode === 'hover');
          var visible = [];

          function sync() {
            if (!pickOne) {
              reels.forEach(function (r) {
                if (visible.indexOf(r) >= 0) play(r); else stop(r);
              });
              return;
            }
            var best = null, bestD = Infinity,
                cx = window.innerWidth / 2, cy = window.innerHeight / 2;
            visible.forEach(function (r) {
              var b = r.getBoundingClientRect();
              var d = Math.abs((b.left + b.right) / 2 - cx)
                    + Math.abs((b.top + b.bottom) / 2 - cy);
              if (d < bestD) { bestD = d; best = r; }
            });
            reels.forEach(function (r) { if (r === best) play(r); else stop(r); });
          }

          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              var i = visible.indexOf(e.target);
              if (e.isIntersecting && e.intersectionRatio >= 0.55) {
                if (i < 0) visible.push(e.target);
              } else if (i >= 0) {
                visible.splice(i, 1);
                stop(e.target);
              }
            });
            sync();
          }, { threshold: [0, 0.55, 1] });
          reels.forEach(function (r) { io.observe(r); });

          // 橫向捲軌道時「誰離中心最近」一直在變，但 IO 的門檻沒跨過就不會再觸發，
          // 所以捲動要自己再算一次。
          if (pickOne) {
            var re = throttle(sync, 180);
            var rail = root.querySelector('.ts-feed__rail');
            if (rail) rail.addEventListener('scroll', re, { passive: true });
            window.addEventListener('scroll', re, { passive: true });
          }
        }
      }

      // ── 點開之後的播放器 ──
      // 主題的容器常有 overflow:hidden 或 transform，會讓 position:fixed 失效，
      // 所以把播放器搬到 <body> 底下。
      var wrap = root.parentElement;
      var player = wrap ? wrap.querySelector('.ts-player') : null;
      if (!player) return;
      document.body.appendChild(player);
      root.__player = player;

      var pv = player.querySelector('.ts-player__v'),
          pAt = player.querySelector('.ts-player__at'),
          pProd = player.querySelector('.ts-player__prod'),
          pThumb = player.querySelector('.ts-player__thumb'),
          pThumbImg = pThumb ? pThumb.querySelector('img') : null,
          pName = player.querySelector('.ts-player__pn'),
          pDesc = player.querySelector('.ts-player__pd'),
          pCta = player.querySelector('.ts-player__cta'),
          navL = player.querySelector('.ts-player__nav--l'),
          navR = player.querySelector('.ts-player__nav--r');
      var cur = -1, lastFocus = null, scrollLock = '';

      function show(el, on) { if (el) el.style.display = on ? '' : 'none'; }

      function load(i) {
        if (i < 0 || i >= reels.length) return;
        cur = i;
        var d = reels[i].dataset;

        pv.src = d.src || '';
        pv.load();
        var pr = pv.play();
        if (pr && pr.catch) pr.catch(function () {});

        if (pAt) { pAt.textContent = d.who || ''; show(pAt, !!d.who); }
        if (pName) pName.textContent = d.pname || '';
        if (pDesc) { pDesc.textContent = d.pdesc || ''; show(pDesc, !!d.pdesc); }
        if (pThumbImg) { pThumbImg.src = d.pimg || ''; }
        show(pThumb, !!d.pimg);
        show(pProd, !!d.pname);
        if (pProd) pProd.href = d.purl || '#';
        if (pCta) { pCta.href = d.purl || '#'; show(pCta, !!d.purl); }

        if (navL) navL.disabled = (i === 0);
        if (navR) navR.disabled = (i === reels.length - 1);
      }

      function open(i) {
        lastFocus = document.activeElement;
        stopAll();
        player.hidden = false;
        scrollLock = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        load(i);
        var x = player.querySelector('.ts-player__x');
        if (x) x.focus();
      }
      function close() {
        player.hidden = true;
        pv.pause();
        pv.removeAttribute('src');
        pv.load();                       // 不清掉會繼續在背景緩衝
        document.body.style.overflow = scrollLock;
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
      function step(n) {
        var i = cur + n;
        if (i >= 0 && i < reels.length) load(i);
      }

      reels.forEach(function (r, i) {
        r.addEventListener('click', function () {
          // 有填「外部連結」的格子直接開原片（例如 YouTube），不開站內播放器
          if (r.dataset.link) { window.open(r.dataset.link, '_blank', 'noopener'); return; }
          open(i);
        });
      });
      player.querySelector('.ts-player__x').addEventListener('click', close);
      if (navL) navL.addEventListener('click', function () { step(-1); });
      if (navR) navR.addEventListener('click', function () { step(1); });
      player.addEventListener('click', function (e) { if (e.target === player) close(); });

      document.addEventListener('keydown', function (e) {
        if (player.hidden) return;
        if (e.key === 'Escape') { e.preventDefault(); close(); }
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); step(-1); }
        else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); step(1); }
      });

      // 手機沒有左右翻頁鍵（會擋到影片），改成用滑的——上下左右都算
      var sx = 0, sy = 0;
      player.addEventListener('touchstart', function (e) {
        sx = e.changedTouches[0].clientX; sy = e.changedTouches[0].clientY;
      }, { passive: true });
      player.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) < 50 && Math.abs(dy) < 50) return;
        if (Math.abs(dx) > Math.abs(dy)) step(dx < 0 ? 1 : -1);
        else step(dy < 0 ? 1 : -1);
      }, { passive: true });
    }

    function boot() { document.querySelectorAll('.ts-feed').forEach(setup); }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    // 佈景主題編輯器裡新增／搬動區塊時會重新塞 DOM，要重新接一次
    document.addEventListener('shopify:section:load', boot);
    // 區塊被刪掉時，先前搬到 body 的播放器要一起收掉，不然會留在頁面上
    document.addEventListener('shopify:section:unload', function (e) {
      var f = e.target.querySelector ? e.target.querySelector('.ts-feed') : null;
      if (f && f.__player && f.__player.parentElement) {
        f.__player.parentElement.removeChild(f.__player);
      }
      document.body.style.overflow = '';
    });
  })();
}
